import { render, staticRenderFns } from "./TestingHistory.vue?vue&type=template&id=b01a461a&"
import script from "./TestingHistory.vue?vue&type=script&lang=js&"
export * from "./TestingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports